import React from 'react';
import { StarIcon } from 'lucide-react';
interface TestimonialProps {
  quote: string;
  author: string;
  image?: string;
  rating?: number;
}
export const Testimonial = ({
  quote,
  author,
  image,
  rating = 5
}: TestimonialProps) => {
  return <div className="bg-white p-6 rounded-lg shadow-md" data-id="element-79">
      <div className="flex space-x-1 mb-3" data-id="element-80">
        {[...Array(rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 text-yellow-400 fill-current" data-id="element-81" />)}
      </div>
      <p className="text-gray-700 italic mb-4" data-id="element-82">"{quote}"</p>
      <div className="flex items-center" data-id="element-83">
        {image && <img src={image} alt={author} className="w-10 h-10 rounded-full object-cover mr-3" style={{
        minWidth: '40px'
      }} data-id="element-84" />}
        <span className="font-medium text-gray-900" data-id="element-85">{author}</span>
      </div>
    </div>;
};